import React from 'react';
import { useParams } from 'react-router-dom';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { EditDisplayTemplatePageComponent } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { withFullScreenWithSummaryBar } from '@bingads-webui-react/app-layout-container';

import { notificationApi } from '../../adapters/get-notification';

const EditDisplayTemplatePage = (props) => {
  const { displayTemplateId: imageId } = useParams();

  return (<EditDisplayTemplatePageComponent imageId={imageId} {...props} notificationApi={notificationApi} />);
};

const PageWithInstrumentation = withFullScreenWithSummaryBar(withInstrumentation(EditDisplayTemplatePage));

export { PageWithInstrumentation as EditDisplayTemplatePage };
